import Error from '../model/Error'
import SignableLetter from '../dto/letter/SignableLetter.js';
import axios from 'axios';

export default class SignableLetterRepository {
    static find(signableLetterId) {
        return new Promise((resolve, reject) => {
            axios.get(`/signable-letters/${signableLetterId}`)
                .then(response => resolve(SignableLetter.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));

        });
    }

    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios.get(`/kindergartens/${kindergartenId}/signable-letters`)
                .then(response => resolve(response.data.data.map(d => SignableLetter.fromData(d))))
                .catch(error => reject(Error.fromResponse(error.response)));

        });
    }

    static sendReminder(signableLetterId) {
        return new Promise((resolve, reject) => {
            axios.post(`/signable-letters/${signableLetterId}/reminder`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));

        });
    }

    static markComplete(signableLetterId) {
        return new Promise((resolve, reject) => {
            axios.patch(`/signable-letters/${signableLetterId}`, { complete: true })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));

        });
    }
}
